/**
 * Page /service-technique/etats-des-lieux/templates — gestion des templates
 * d'état des lieux (mig 216). Manager+ (l'agent ne voit pas cet onglet ; il
 * utilise les templates via le bouton « État des lieux » de la liste).
 */
import { ClipboardList } from 'lucide-react';
import { AppHeader } from '@/components/AppHeader';
import { ServiceTechniqueNav } from '@/components/ServiceTechniqueNav';
import { LogoMark, SectionEyebrow } from '@/components/ui';
import { EdlTemplatesPanel } from '@/pages/service-technique/EdlTemplatesPanel';
import { EtatsDesLieuxListPanel } from '@/pages/service-technique/EtatsDesLieuxListPanel';

export function EdlTemplatesPage() {
  return (
    <div className="min-h-screen text-ink">
      <AppHeader module="Service technique" accent="tech" />
      <nav
        aria-label="Navigation Service technique"
        className="border-b border-border backdrop-blur-glass px-4 py-2"
        style={{ backgroundImage: 'linear-gradient(180deg, oklch(var(--c-bg-2) / 0.3), oklch(var(--c-bg) / 0.4))' }}
      >
        <div className="mx-auto max-w-6xl">
          <ServiceTechniqueNav active="edl_templates" />
        </div>
      </nav>

      <main id="main-content" className="mx-auto max-w-5xl px-4 py-6 animate-fade-in">
        <div className="flex items-center gap-3 mb-5">
          <LogoMark icon={ClipboardList} accent="tech" size="lg" />
          <div>
            <SectionEyebrow as="div">Service technique</SectionEyebrow>
            <h1 className="text-2xl font-semibold text-ink">États des lieux</h1>
            <p className="mt-1 text-sm text-ink-muted">
              Retrouvez ici les états des lieux réalisés, et préparez un modèle par lieu
              (les points à vérifier). Sur le terrain, l'agent crée un état des lieux depuis
              le modèle et coche OK / à surveiller / dégradé.
            </p>
          </div>
        </div>

        {/* 1. États des lieux réels (avec bouton de création). */}
        <EtatsDesLieuxListPanel />

        {/* 2. Templates (modèles par lieu). */}
        <div className="mt-8 border-t border-border pt-6">
          <h2 className="mb-3 text-sm font-semibold text-ink">Modèles par lieu</h2>
          <EdlTemplatesPanel />
        </div>
      </main>
    </div>
  );
}
